<template>
  <div class="detaill">
    <!-- 返回 -->
    <!-- <div class="back" v-show="showback">
      <img
        :src="'https://puui.qpic.cn/vupload/0/20200709_mixpjrqf0a/0'"
        class="details-img"
        @click="Goback"
      />
      <div class="details-return" @click="Goback">返回</div>
    </div> -->
    <!-- 头部 -->
    <el-card class="box-card">
      <div class="header">
        <div class="up">
          <div class="user">
            <div class="avatar">
              <!-- <el-avatar
                :size="60"
                src="./默认头像.png"
              ></el-avatar> -->
              <img :src="g_imgSrc.doctorDefault" alt="" />
            </div>

            <h4>{{ hospitalInfo.hospital_name || '-' }}</h4>
          </div>
          <div class="company">
            <div class="item">
              <div class="title">省市</div>
              <div class="data">
                {{ hospitalInfo.province_name + hospitalInfo.city_name || '-' }}
              </div>
            </div>
            <div class="item">
              <div class="title">等级</div>
              <div class="data">{{ hospitalInfo.hospital_level || '-' }}</div>
            </div>
            <div class="item">
              <div class="title">类型</div>
              <div class="data">{{ hospitalInfo.type || '-' }}</div>
            </div>
            <div class="item">
              <div class="title">经营性质</div>
              <div class="data">{{ hospitalInfo.attribute || '-' }}</div>
            </div>
            <div class="item">
              <div class="title">覆盖医生数</div>
              <div class="data">{{ hospitalInfo.doctor_num || '-' }}</div>
            </div>
            <div class="item">
              <div class="title">注册医生比例</div>
              <div class="data">{{ hospitalInfo.register_percent * 100 + '%' || '-' }}</div>
            </div>
            <div class="item">
              <div class="title">授权医生比例</div>
              <div class="data">{{ hospitalInfo.auth_percent * 100 + '%' || '-' }}</div>
            </div>
          </div>
        </div>
      </div>
    </el-card>
    <br />
    <!-- 关联医生列表 -->
    <el-card class="box-card">
      <div>
        <el-form inline>
          <el-form-item label="所属科室:">
            <el-select v-model="query.department_name" placeholder="请选择科室">
              <el-option
                v-for="item in hospitalDepartmentList"
                :key="item.value"
                :label="item.department_name"
                :value="item.department_name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="医生姓名:">
            <el-input v-model="query.doctor_name" placeholder="请输入医生姓名"></el-input>
          </el-form-item>
          <el-form-item label="医生职称:">
            <el-select v-model="query.title" placeholder="请选择职称">
              <el-option
                v-for="item in doctorTitleList"
                :key="item.value"
                :label="item.title_name"
                :value="item.title_name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">筛选</el-button>
            <el-button @click="exportData">导出文档</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-list">
        <el-table :data="tableData" style="width: 100%" v-loading="tableLoding">
          <el-table-column prop="doctor_name" label="医生姓名">
            <template slot-scope="scope">
              <div>{{ scope.row.doctor_name ? scope.row.doctor_name : '-' }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="hospital_name" label="医院" />
          <el-table-column prop="department_name" label="科室" />
          <el-table-column prop="title" label="职称" />
          <el-table-column prop="auth_status" label="注册状态">
            <template slot-scope="scope">
              <div v-if="scope.row.is_registered === 1">未注册</div>
              <div v-if="scope.row.auth_status === 2">已注册</div>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="showdoctorDetaill(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        class="pagination"
        style="background-color: #ffffff"
        layout="total,sizes, prev, pager, next, jumper"
        :total="total"
        :page-sizes="g_pageSizesConfig"
        :page-size="query.page_size"
        :current-page="query.page_index"
        @current-change="doctorhandleCurrentChange"
      />
      <br />
      <br />
    </el-card>
  </div>
</template>

<script>
import { queryHospitalInfoApi, queryDoctorInfoByHospital } from '@/api/dataCenter';
import { getHospitalDepartmentListApi, QueryTitleList } from '@/api/setUp.js';
import { jsonToXlsx } from '@/utils/xlsx.js';
export default {
  data() {
    return {
      showback: true,
      tableLoding: false,
      hospitalInfo: {
        attribute: '',
        auth_percent: null,
        city_name: '',
        doctor_num: null,
        hospital_level: '',
        hospital_name: '',
        operation_type: '',
        province_name: '',
        register_percent: null,
        type: '',
      },
      query: {
        hospital_id: '',
        department_name: '',
        doctor_name: '',
        title: '',
        page_index: 1,
        page_size: this.g_pageSizeDefault,
      },
      total: 0,
      tableData: [],
      hospitalDepartmentList: [],
      doctorTitleList: [],
    };
  },
  created() {
    // 判断是否新打开的页面
    this.query.page_size = this.g_pageSizeDefault;
    const { query } = this.$route;
    if (query.type === 'newWindow') {
      this.showback = false;
    }
    this.getTableList();
    queryHospitalInfoApi({ hospital_id: this.$route.query.id })
      .then((res) => {
        this.hospitalInfo = res;
      })
      .catch((err) => {
        this.$message.error(err.message);
      });
    getHospitalDepartmentListApi({ hospital_id: this.$route.query.id }).then((res) => {
      this.hospitalDepartmentList = res.data;
    });
    QueryTitleList({ page_index: 1, page_size: 9999 }).then((res) => {
      this.doctorTitleList = res.data;
    });
  },
  mounted() {
    if (this.$route.query.type) {
      this.init();
    }
  },
  methods: {
    jsonToXlsx,
    init() {
      const breadcrumb = [
        { menu_name: '用户管理', menu_path: '', menu_params: {} },
        { menu_name: '机构管理', menu_path: 'allergan_InstitutionalManage', menu_params: {} },
        { menu_name: '医院详情', menu_params: { componentName: 'hospitalDetail' } },
      ];
      this.g_breadcrumb(breadcrumb);
    },
    exportData() {
      if (this.tableData.length === 0) {
        this.$message.warning('暂无数据可导出');
        return false;
      }
      const arr = this.tableData.map((item) => {
        if (item.is_registered === 1) {
          return {
            医生姓名: item.doctor_name,
            医院: item.hospital_name,
            科室: item.department_name,
            职称: item.title,
            注册状态: '未注册',
          };
        }
        if (item.is_registered === 2) {
          return {
            医生姓名: item.doctor_name,
            医院: item.hospital_name,
            科室: item.department_name,
            职称: item.title,
            注册状态: '已注册',
          };
        }
      });
      this.jsonToXlsx([{ sheet: arr, name: '医生详情文档' }], '导出文档');
    },
    doctorhandleCurrentChange(val) {
      this.query.page_index = val;
      this.getTableList();
    },
    handleSizeChange(val) {
      this.query.page_size = val;
      this.getTableList();
    },
    // // 返回
    Goback() {
      this.$router.go(-1);
      // 新窗口打开的关闭窗口
      window.close();
    },
    getTableList() {
      this.tableLoding = true;
      this.query.hospital_id = this.$route.query.id;
      queryDoctorInfoByHospital(this.query).then((res) => {
        this.tableData = res.data;
        this.total = res.total_num;
        this.tableLoding = false;
      });
    },
    onSubmit() {
      this.query.page_index = 1;
      this.getTableList(this.query);
    },
    showdoctorDetaill(row) {
      const id = row.doctor_id;
      this.g_tourl(`/saas/doctorInfo.html?doctor_id=${id}&type=newWindow`, { open: true });
    },
  },
};
</script>

<style scoped lang="scss">
@import './index.scss';
</style>
